import React from "react";
var __jsx = React.createElement;
import stl from "./HeroArea.module.css";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
export var HeroArea = function HeroArea() {
  var lang = useLang();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.heroArea
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.mainTitleSection
  }, /*#__PURE__*/React.createElement("h1", {
    className: stl.textWrapper
  }, t("syarah_trends", {
    ns: "web_trend"
  })))), /*#__PURE__*/React.createElement("img", {
    className: stl.illustration,
    alt: "Syarah trend",
    src: "".concat(CDN_LINK, "/assets/images/trend/trend_").concat(lang === "ar" ? "ar" : "en", ".svg"),
    loading: "eager",
    width: 430,
    height: 155
  }));
};